import {
  Tooltip,
  Button,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Switch
} from '@mui/material'
import { Formik } from 'formik'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import AddIcon from '@mui/icons-material/Add'
import { Delete } from '@mui/icons-material'
import CustomButton from '../../shared/CustomButton'

function CreatePriceListForm () {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const handleGoBack = () => {
    navigate(-1)
  }

  const [companies, setCompanies] = useState([
    { name: 'Rupa Arabia', active: true },
    { name: 'Tawuniya', active: true },
    { name: 'Medgulf', active: true },
    { name: 'Malath', active: true }
  ])

  const initialValues = {
    selectType: '',
    selectSubType: '',
    department: '',
    nonstandardDescription: '',
    materPrice: '',
    standardCode: '',
    standardDescription: '',

    selectItemType: '',
    effectiveDate: '',
    endDate: '',

    outPatient: '',
    itemPrice: '',
    internalCost: '',
    discountAmount: '',
    discountPercentage: '',
    branchOrLocation: '',

    emergencyItemPrice: '',
    emergencyInternalCost: '',
    emergencyDiscountAmount: '',
    emergencyDiscountPercentage: '',
    emergencyBranchOrLocation: '',

    inpatientItemPrice: '',
    inpatientInternalCost: '',
    inpatientDiscountAmount: '',
    inpatientDiscountPercentage: '',
    inpatientBranchOrLocation: '',

    itSpecial: false,
    applyVat: false,
    dailyPackageDeal: false,
    orderChangeablePrice: false,
    payer: []
  }

  const validationSchema = Yup.object().shape({
    selectType: Yup.string().required('Required'),
    selectItemType: Yup.string().required('Required'),
    effectiveDate: Yup.date().required('Required')
  })

  const handleSubmit = values => {
    console.log('Form submitted:', values)
  }

  const addNewPayer = () => {
    console.log('Add new payer clicked')
  }

  return (
    <div className='superGit_container'>
      <div className='benefeciary-create'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit}>
              <div className='patient-details !mb-3'>
                <div className='flex items-center gap-2 !mb-2'>
                  <div className='inventory-svg'>
                    <svg
                      width='26'
                      height='26'
                      viewBox='0 0 34 34'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <rect width='34' height='34' rx='8' fill='#F4F6F8' />
                      <path
                        d='M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z'
                        fill='#F5793B'
                      />
                      <path
                        d='M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z'
                        fill='#F5793B'
                      />
                    </svg>
                  </div>
                  <div className='personal-head'>
                    <span>{t('General Information')}</span>
                  </div>
                </div>
                <div className='mt-6'>
                  <div className='details-fields grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-3'>
                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Select Type')}</label>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='selectType'
                          value={values.selectType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                          displayEmpty
                        >
                          <MenuItem value='' disabled>
                            Select Type
                          </MenuItem>
                          <MenuItem value='type1'>Type 1</MenuItem>
                          <MenuItem value='type2'>Type 2</MenuItem>
                        </Select>
                      </FormControl>
                      {errors.selectType && touched.selectType && (
                        <p className='max-w-2xl text-sm leading-6 text-red-500'>
                          {errors.selectType}
                        </p>
                      )}
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Select Sub Type')}</label>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='selectSubType'
                          value={values.selectSubType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                          displayEmpty
                        >
                          <MenuItem value='' disabled>
                            Select Sub Type
                          </MenuItem>
                          <MenuItem value='subType1'>Sub Type 1</MenuItem>
                          <MenuItem value='subType2'>Sub Type 2</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Department')}</label>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='department'
                          value={values.department}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                          displayEmpty
                        >
                          <MenuItem value='' disabled>
                            Select Department
                          </MenuItem>
                          <MenuItem value='dept1'>Department 1</MenuItem>
                          <MenuItem value='dept2'>Department 2</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>
                        {t('Nonstandard Description')}
                      </label>
                      <input
                        placeholder={t('Enter Nonstandard Description')}
                        type='text'
                        name='nonstandardDescription'
                        value={values.nonstandardDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Mater Price')}</label>
                      <input
                        placeholder={t('Enter Mater Price')}
                        type='number'
                        name='materPrice'
                        value={values.materPrice}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Standard Code')}</label>
                      <input
                        placeholder={t('Enter Standard Code')}
                        type='text'
                        name='standardCode'
                        value={values.standardCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>
                        {t('Standard Description')}
                      </label>
                      <input
                        placeholder={t('Enter Standard Description')}
                        type='text'
                        name='standardDescription'
                        value={values.standardDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Select Item Type')}</label>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='selectItemType'
                          value={values.selectItemType}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                          displayEmpty
                        >
                          <MenuItem value='' disabled>
                            Select Item Type
                          </MenuItem>
                          <MenuItem value='itemType1'>Item Type 1</MenuItem>
                          <MenuItem value='itemType2'>Item Type 2</MenuItem>
                        </Select>
                      </FormControl>
                      {errors.selectItemType && touched.selectItemType && (
                        <p className='max-w-2xl text-sm leading-6 text-red-500'>
                          {errors.selectItemType}
                        </p>
                      )}
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Effective Date')}</label>
                      <input
                        type='date'
                        name='effectiveDate'
                        value={values.effectiveDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                      {errors.effectiveDate && touched.effectiveDate && (
                        <p className='max-w-2xl text-sm leading-6 text-red-500'>
                          {errors.effectiveDate}
                        </p>
                      )}
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('End Date')}</label>
                      <input
                        type='date'
                        name='endDate'
                        value={values.endDate}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='patient-details !mb-3'>
                <div className='flex items-center gap-2 !mb-2'>
                  <div className='inventory-svg'>
                    <svg
                      width='26'
                      height='26'
                      viewBox='0 0 34 34'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <rect width='34' height='34' rx='8' fill='#F4F6F8' />
                      <path
                        d='M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z'
                        fill='#F5793B'
                      />
                      <path
                        d='M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z'
                        fill='#F5793B'
                      />
                    </svg>
                  </div>
                  <div className='personal-head'>
                    <span>{t('Pricing Details')}</span>
                  </div>
                </div>

                {/* Out Patient */}
                <div className='mt-3'>
                  <div className='flex items-center gap-2 mb-2'>
                    <span className='text-sm font-medium'>
                      {t('Out Patient')}
                    </span>
                  </div>
                  <div className='details-fields grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 gap-3'>
                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Item Price')}</label>
                      <input
                        placeholder={t('Enter Item Price')}
                        type='number'
                        name='itemPrice'
                        value={values.itemPrice}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Internal Cost')}</label>
                      <input
                        placeholder={t('Enter Internal Cost')}
                        type='number'
                        name='internalCost'
                        value={values.internalCost}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Discount Amount')}</label>
                      <input
                        placeholder={t('Enter Discount Amount')}
                        type='number'
                        name='discountAmount'
                        value={values.discountAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>
                        {t('Discount Percentage')}
                      </label>
                      <input
                        placeholder={t('Enter Discount Percentage')}
                        type='number'
                        name='discountPercentage'
                        value={values.discountPercentage}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>
                        {t('Branch or Location')}
                      </label>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='branchOrLocation'
                          value={values.branchOrLocation}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                          displayEmpty
                        >
                          <MenuItem value='' disabled>
                            Select Branch/Location
                          </MenuItem>
                          <MenuItem value='branch1'>Branch 1</MenuItem>
                          <MenuItem value='branch2'>Branch 2</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>

                {/* Emergency */}
                <div className='mt-3'>
                  <div className='flex items-center gap-2 mb-2'>
                    <span className='text-sm font-medium'>
                      {t('Emergency')}
                    </span>
                  </div>
                  <div className='details-fields grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 gap-3'>
                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Item Price')}</label>
                      <input
                        placeholder={t('Enter Item Price')}
                        type='number'
                        name='emergencyItemPrice'
                        value={values.emergencyItemPrice}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Internal Cost')}</label>
                      <input
                        placeholder={t('Enter Internal Cost')}
                        type='number'
                        name='emergencyInternalCost'
                        value={values.emergencyInternalCost}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Discount Amount')}</label>
                      <input
                        placeholder={t('Enter Discount Amount')}
                        type='number'
                        name='emergencyDiscountAmount'
                        value={values.emergencyDiscountAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>
                        {t('Discount Percentage')}
                      </label>
                      <input
                        placeholder={t('Enter Discount Percentage')}
                        type='number'
                        name='emergencyDiscountPercentage'
                        value={values.emergencyDiscountPercentage}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>
                        {t('Branch or Location')}
                      </label>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='emergencyBranchOrLocation'
                          value={values.emergencyBranchOrLocation}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                          displayEmpty
                        >
                          <MenuItem value='' disabled>
                            Select Branch/Location
                          </MenuItem>
                          <MenuItem value='branch1'>Branch 1</MenuItem>
                          <MenuItem value='branch2'>Branch 2</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>

                {/* Inpatient */}
                <div className='mt-3'>
                  <div className='flex items-center gap-2 mb-2'>
                    <span className='text-sm font-medium'>
                      {t('Inpatient')}
                    </span>
                  </div>
                  <div className='details-fields grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 gap-3'>
                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Item Price')}</label>
                      <input
                        placeholder={t('Enter Item Price')}
                        type='number'
                        name='inpatientItemPrice'
                        value={values.inpatientItemPrice}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Internal Cost')}</label>
                      <input
                        placeholder={t('Enter Internal Cost')}
                        type='number'
                        name='inpatientInternalCost'
                        value={values.inpatientInternalCost}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>{t('Discount Amount')}</label>
                      <input
                        placeholder={t('Enter Discount Amount')}
                        type='number'
                        name='inpatientDiscountAmount'
                        value={values.inpatientDiscountAmount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>
                        {t('Discount Percentage')}
                      </label>
                      <input
                        placeholder={t('Enter Discount Percentage')}
                        type='number'
                        name='inpatientDiscountPercentage'
                        value={values.inpatientDiscountPercentage}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                      />
                    </div>

                    <div className='flex gap-1 flex-col'>
                      <label className='text-sm'>
                        {t('Branch or Location')}
                      </label>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='inpatientBranchOrLocation'
                          value={values.inpatientBranchOrLocation}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                          displayEmpty
                        >
                          <MenuItem value='' disabled>
                            Select Branch/Location
                          </MenuItem>
                          <MenuItem value='branch1'>Branch 1</MenuItem>
                          <MenuItem value='branch2'>Branch 2</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>

              <div className='patient-details !mb-3'>
                <div className='flex items-center gap-2 !mb-2'>
                  <div className='inventory-svg'>
                    <svg
                      width='26'
                      height='26'
                      viewBox='0 0 34 34'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <rect width='34' height='34' rx='8' fill='#F4F6F8' />
                      <path
                        d='M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z'
                        fill='#F5793B'
                      />
                      <path
                        d='M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z'
                        fill='#F5793B'
                      />
                    </svg>
                  </div>
                  <div className='personal-head'>
                    <span>{t('Tax & Special Pricing Options')}</span>
                  </div>
                </div>

                <div className='mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3'>
                  <div>
                    <label className='text-sm'>Is Special</label>
                    <div className='flex w-full rounded overflow-hidden border border-gray-300'>
                      <div
                        onClick={() => setFieldValue('itSpecial', true)}
                        className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                          values?.itSpecial
                            ? '!bg-primary text-white'
                            : 'bg-transparent text-black'
                        }`}
                      >
                        True
                      </div>
                      <div
                        onClick={() => setFieldValue('itSpecial', false)}
                        className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                          !values?.itSpecial
                            ? '!bg-primary text-white'
                            : 'bg-transparent text-black'
                        }`}
                      >
                        False
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className='text-sm'>Apply Vat</label>
                    <div className='flex w-full rounded overflow-hidden border border-gray-300'>
                      <div
                        onClick={() => setFieldValue('applyVat', true)}
                        className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                          values?.applyVat
                            ? '!bg-primary text-white'
                            : 'bg-transparent text-black'
                        }`}
                      >
                        True
                      </div>
                      <div
                        onClick={() => setFieldValue('applyVat', false)}
                        className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                          !values?.applyVat
                            ? '!bg-primary text-white'
                            : 'bg-transparent text-black'
                        }`}
                      >
                        False
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className='text-sm'>Daily Package Deal</label>
                    <div className='flex w-full rounded overflow-hidden border border-gray-300'>
                      <div
                        onClick={() => setFieldValue('dailyPackageDeal', true)}
                        className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                          values?.dailyPackageDeal
                            ? '!bg-primary text-white'
                            : 'bg-transparent text-black'
                        }`}
                      >
                        True
                      </div>
                      <div
                        onClick={() => setFieldValue('dailyPackageDeal', false)}
                        className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                          !values?.dailyPackageDeal
                            ? '!bg-primary text-white'
                            : 'bg-transparent text-black'
                        }`}
                      >
                        False
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className='text-sm'>Order Changeable Price</label>
                    <div className='flex w-full rounded overflow-hidden border border-gray-300'>
                      <div
                        onClick={() =>
                          setFieldValue('orderChangeablePrice', true)
                        }
                        className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                          values?.orderChangeablePrice
                            ? '!bg-primary text-white'
                            : 'bg-transparent text-black'
                        }`}
                      >
                        True
                      </div>
                      <div
                        onClick={() =>
                          setFieldValue('orderChangeablePrice', false)
                        }
                        className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                          !values?.orderChangeablePrice
                            ? '!bg-primary text-white'
                            : 'bg-transparent text-black'
                        }`}
                      >
                        False
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='patient-details !mb-3'>
                <div className='flex items-center gap-2 !mb-2'>
                  <div className='inventory-svg'>
                    <svg
                      width='26'
                      height='26'
                      viewBox='0 0 34 34'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <rect width='34' height='34' rx='8' fill='#F4F6F8' />
                      <path
                        d='M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z'
                        fill='#F5793B'
                      />
                      <path
                        d='M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z'
                        fill='#F5793B'
                      />
                    </svg>
                  </div>
                  <div className='personal-head'>
                    <span>{t('Companies Specifications')}</span>
                  </div>
                </div>
                <div>
                  <div className='flex gap-1 flex-col'>
                    <label className='text-sm'>{t('Branch or Location')}</label>
                    <FormControl fullWidth size='small'>
                      <Select
                        name='branchOrLocation'
                        value={values.branchOrLocation}
                        onChange={e => {
                          setFieldValue('payer', [
                            ...values?.payer,
                            {
                              Payer: e.target?.value,
                              Price: 0,
                              agreedCode: '',
                              agreedDescription: '',
                              companyDiscountAmount: 0,
                              companyDiscountPercentage: 0,
                              companyEffectiveDate: '',
                              companyEndDate: '',
                              approval: true,
                              branchOrLocation: ''
                            }
                          ])
                        }}
                        onBlur={handleBlur}
                        className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                        displayEmpty
                      >
                        <MenuItem value='' disabled>
                          Select Branch/Location
                        </MenuItem>
                        <MenuItem value='branch1'>Branch 1</MenuItem>
                        <MenuItem value='branch2'>Branch 2</MenuItem>
                      </Select>
                    </FormControl>
                    <table className='min-w-full divide-y divide-gray-200 mt-3'>
                      <thead className='bg-gray-50'>
                        <tr>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Payer
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Price
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Agreed Code
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Agreed Description
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Discount Amount
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Discount Percentage
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Effective Date
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            End Date
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Approval
                          </th>
                          <th className='px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className='bg-white divide-y divide-gray-200'>
                        {values?.payer?.map((item, index) => (
                          <tr key={index}>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <input
                                disabled
                                placeholder={t('Enter Payer')}
                                type='text'
                                name={`payer[${index}].Payer`}
                                value={item?.Payer}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                              />
                            </td>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <input
                                placeholder={t('Enter Price')}
                                type='number'
                                name={`payer[${index}].Price`}
                                value={item?.Price}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                              />
                            </td>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <input
                                placeholder={t('Enter Agreed Code')}
                                type='text'
                                name={`payer[${index}].agreedCode`}
                                value={item?.agreedCode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                              />
                            </td>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <input
                                placeholder={t('Enter Agreed Description')}
                                type='text'
                                name={`payer[${index}].agreedDescription`}
                                value={item?.agreedDescription}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                              />
                            </td>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <input
                                placeholder={t('Enter Discount Amount')}
                                type='number'
                                name={`payer[${index}].companyDiscountAmount`}
                                value={item?.companyDiscountAmount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                              />
                            </td>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <input
                                placeholder={t('Enter Discount Percentage')}
                                type='number'
                                name={`payer[${index}].companyDiscountPercentage`}
                                value={item?.companyDiscountPercentage}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                              />
                            </td>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <input
                                placeholder={t('Enter')}
                                type='date'
                                name={`payer[${index}].companyEffectiveDate`}
                                value={item?.companyEffectiveDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                              />
                            </td>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <input
                                placeholder={t('Enter')}
                                type='date'
                                name={`payer[${index}].companyEndDate`}
                                value={item?.companyEndDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm'
                              />
                            </td>
                            <td className='px-1 py-2 whitespace-nowrap'>
                              <div className='flex w-full rounded overflow-hidden border border-gray-300'>
                                <div
                                  onClick={() =>
                                    setFieldValue(
                                      `payer[${index}].approval`,
                                      true
                                    )
                                  }
                                  className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                                    values?.payer[index]?.approval
                                      ? '!bg-primary text-white'
                                      : 'bg-transparent text-black'
                                  }`}
                                >
                                  True
                                </div>
                                <div
                                  onClick={() =>
                                    setFieldValue(
                                      `payer[${index}].approval`,
                                      false
                                    )
                                  }
                                  className={`w-1/2 text-center cursor-pointer py-2 transition-all ${
                                    !values?.payer[index]?.approval
                                      ? '!bg-primary text-white'
                                      : 'bg-transparent text-black'
                                  }`}
                                >
                                  False
                                </div>
                              </div>
                            </td>
                            <td className='px-6 py-4 whitespace-nowrap'>
                              <button
                                type='button'
                                onClick={() => {
                                  const newPayers = values.payer.filter(
                                    (_, i) => i !== index
                                  )
                                  setFieldValue('payer', newPayers)
                                }}
                                className='text-red-600 hover:text-red-900 focus:outline-none'
                              >
                                <Delete />
                                <span className='sr-only'>Delete</span>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className='flex justify-end mt-4'>
                <CustomButton
                  label='Submit'
                  icon={<DoneAllIcon />}
                  type='submit'
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default CreatePriceListForm
